module.exports = __webpack_public_path__ + "img/2.a83fce9e.jpg";